import { useEffect } from 'react';
import options from '../../data/options';
import {
  setDisableNext,
  setDisablePrev,
  setSelectedOption,
} from '../../features/providers/dataSlice';
import { useDispatch, useSelector } from 'react-redux';

const Step0 = ({ number }) => {
  const dispatch = useDispatch();
  const selectedOption = useSelector((state) => state.data.selectedOption);

  useEffect(() => {
    dispatch(setDisableNext({ number, disabled: selectedOption === null }));
    dispatch(setDisablePrev({ number, disabled: true }));
  }, [selectedOption, dispatch, number]);

  // Helper function for handling option selection via both click and keyboard
  const handleOptionSelect = (i) => {
    dispatch(setSelectedOption(i === selectedOption ? null : i));
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-5 px-5">
      {options.map(({ title, description }, i) => (
        <button
          key={i}
          className={`${
            i === selectedOption ? 'bg-pink' : ''
          } border-[#DEC8FF] border-2 rounded-[5px] text-left flex flex-col gap-5 p-5 cursor-pointer focus:outline-none focus:ring focus:ring-purple-500`}
          onClick={() => handleOptionSelect(i)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleOptionSelect(i);
            }
          }}
          tabIndex={0}
          role="button"
          aria-pressed={i === selectedOption}
          aria-label={`Select option ${title}`}
        >
          <h2 className="text-primary text-h3 font-bold mb-1">{title}</h2>
          {Array.isArray(description) &&
            description.map((desc, index) => (
              <p className="" key={index}>
                {desc}
              </p>
            ))}
        </button>
      ))}
    </div>
  );
};

export default Step0;
